<template>
  <button
    class="preview-video-thumb"
    v-on:click.prevent="$emit('open')"
    aria-label="Feuerwerk in Aktion ansehen"
    aria-controls="videoContainer"
  >
    <div class="label" aria-label="Das Feuerwerk in Aktion, Jetzt Effektvideo ansehen">
      <strong>Das Feuerwerk in Aktion</strong>
      <small>Jetzt Effektvideo ansehen</small>
    </div>
    <div class="video">
      <img :src="previewUrl" alt="Video Vorschau" />
    </div>
  </button>
</template>

<script>
import { mapState } from "vuex";
import CloseButton from "@/components/CloseButton.vue";
export default {
  name: "video-preview",
  props: {
    previewUrl: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "../scss/settings";
.preview-video-thumb {
  text-align: left;
  box-sizing: border-box;
  position: absolute;
  align-items: flex-start;
  right: 65px;
  bottom: 43px;
  z-index: 200;
  color: #ffffff;
  cursor: pointer;
  // transform: translateX(-50%);
  width: 244px;
  max-width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background: transparent;
  z-index: 800;
  padding: 10px;
  .label {
    flex: 1 0 auto;
    padding: 0 0 18px 0;
    line-height: 1;
    justify-content: center;
    align-items: center;
    position: relative;
    strong {
      display: block;
      font-size: px-to-rem(18);
      margin-bottom: 8px;
      color: #ffffff;
    }
    small { 
      color: #ffffff;
      font-size: px-to-rem(16);
    }
    &::after {
      content: "";
      background: transparent url(/assets/images/arrow-down-white.png)
        no-repeat center bottom;
      background-size: 100% auto;
      width: 40px;
      height: 50px;
      position: absolute;
      // right: 10px;
      top: 40px;
      z-index: 300;
      transform: rotate(30deg);
    }
    @include mobile {
      display: none;
    }
  }
  
  @include focus-light-outside(8px);
  
  .video {
    border: solid 2px $dark-bg;
    border-radius: 8px;
    background: #29292D;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &::after {
      content: "";
      width: 38px;
      height: 38px;
      background: transparent url(/assets/images/video-play.png) no-repeat center/cover;
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
    img {
      width: 100%;
      height: auto;
    }
    @include mobile {
      width: 183px;
      height: 97px;
    }
  }
}
</style>
